module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 011.2be88ead.jpg";